import { NgModule } from '@angular/core';
import { defaultSeoConfig } from '@main/schema-org/const';
import { provideDefaultConfig } from '@spartacus/core';
import {
  BreadcrumbSchemaBuilder,
  JsonLdBaseProductBuilder,
  JsonLdProductReviewBuilder,
  ProductSchemaBuilder,
  SCHEMA_BUILDER,
} from '@spartacus/storefront';
import { ArticleDetailSchemaBuilder } from './article-detail-schema.builder';
import { BrandSchemaBuilder } from './brand-schema.builder';
import { CustomBreadcrumbSchemaBuilder } from './breadcrumb-schema.builder';
import { CustomJsonLdBaseProductBuilder } from './jsonld-base-product.builder';
import { CustomJsonLdProductReviewBuilder } from './jsonld-product-review.builder';
import { OrganizationSchemaBuilder } from './organization-schema.builder';
import { CustomProductSchemaBuilder } from './product-schema.builder';
import { SiteNavigationSchemaBuilder } from './site-navigation-schema.builder';

@NgModule({
  providers: [
    provideDefaultConfig(defaultSeoConfig),
    { provide: ProductSchemaBuilder, useExisting: CustomProductSchemaBuilder },
    { provide: JsonLdBaseProductBuilder, useExisting: CustomJsonLdBaseProductBuilder },
    { provide: BreadcrumbSchemaBuilder, useExisting: CustomBreadcrumbSchemaBuilder },
    { provide: JsonLdProductReviewBuilder, useExisting: CustomJsonLdProductReviewBuilder },
    { provide: SCHEMA_BUILDER, multi: true, useExisting: BrandSchemaBuilder },
    { provide: SCHEMA_BUILDER, multi: true, useExisting: OrganizationSchemaBuilder },
    { provide: SCHEMA_BUILDER, multi: true, useExisting: ArticleDetailSchemaBuilder },
    { provide: SCHEMA_BUILDER, multi: true, useExisting: SiteNavigationSchemaBuilder },
  ],
})
export class MainSchemaOrgFeatureModule {}
